import React from "react";
import { Link } from "react-router-dom";
import Carousel, {
  slidesToShowPlugin,
  autoplayPlugin,
} from "@brainhubeu/react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";
import "./carouselHome.scss";

import ico01 from "../../assets/imgs/iconos/services_home/org_congresos.svg";
import ico02 from "../../assets/imgs/iconos/services_home/prod_visual.svg";
import ico03 from "../../assets/imgs/iconos/services_home/envivo.svg";
import ico04 from "../../assets/imgs/iconos/services_home/develop.svg";
import ico05 from "../../assets/imgs/iconos/services_home/design.svg";
import ico06 from "../../assets/imgs/iconos/services_home/marketing.svg";

import { useTranslation } from "react-i18next";

export const CarouselServices = () => {
  const { t } = useTranslation();

  return (
    <div className="wrapper_carousel_home ">
      <Carousel
        plugins={[
          {
            resolve: slidesToShowPlugin,
            options: {
              numberOfSlides: 6,
            },
          },
        ]}
        breakpoints={{
          1024: {
            plugins: [
              "infinite",
              "autoplay",
              {
                resolve: slidesToShowPlugin,
                options: {
                  numberOfSlides: 4,
                },
              },
              {
                resolve: autoplayPlugin,
                options: {
                  interval: 1400,
                },
              },
            ],
          },
          840: {
            plugins: [
              "infinite",
              "autoplay",

              {
                resolve: slidesToShowPlugin,
                options: {
                  numberOfSlides: 3,
                },
              },
              {
                resolve: autoplayPlugin,
                options: {
                  interval: 1400,
                },
              },
            ],
          },
          580: {
            plugins: [
              "infinite",
              "autoplay",

              {
                resolve: slidesToShowPlugin,
                options: {
                  numberOfSlides: 2,
                },
              },
              {
                resolve: autoplayPlugin,
                options: {
                  interval: 1400,
                },
              },
            ],
          },
        }}
        animationSpeed={500}
      >
        <Link to="/organizacion-congresos" className="box_item_datainfo">
          <img
            className="trans"
            src={ico01}
            alt={t("Organización de Congresos")}
          />
          <h3 className="mt-3">{t("Organización de Congresos")}</h3>
        </Link>
        <Link to="/produccion-audiovisual" className="box_item_datainfo ">
          <img
            className="trans"
            src={ico02}
            alt={t("Producción Audiovisual")}
          />
          <h3 className="mt-3">{t("Producción Audiovisual")}</h3>
        </Link>
        <Link to="/streaming" className="box_item_datainfo">
          <img className="trans" src={ico03} alt={t("Streaming")} />
          <h3 className="mt-3">{t("Streaming")}</h3>
        </Link>
        <Link to="/desarrollo-web-apps" className="box_item_datainfo ">
          <img className="trans" src={ico04} alt={t("Desarrollo Web y Apps")} />
          <h3 className="mt-3">{t("Desarrollo Web y Apps")}</h3>
        </Link>
        <Link to="diseno-grafico" className="box_item_datainfo ">
          <img className="trans" src={ico05} alt={t("Diseño Gráfico")} />
          <h3 className="mt-3">{t("Diseño Gráfico")}</h3>
        </Link>
        <Link to="/marketing-y-redes-sociales" className="box_item_datainfo ">
          <img
            className="trans"
            src={ico06}
            alt={t("Marketing y Redes Sociales")}
          />
          <h3 className="mt-3">{t("Marketing y Redes Sociales")}</h3>
        </Link>
      </Carousel>
    </div>
  );
};

export const CarouselStories = () => {
  const { t } = useTranslation();
  return (
    <div className="wrapper_carousel_stories ">
      <Carousel
        plugins={[
          "infinite",
          "arrows",
          {
            resolve: slidesToShowPlugin,
            options: {
              numberOfSlides: 3,
            },
          },
          {
            resolve: autoplayPlugin,
            options: {
              interval: 5000,
            },
          },
          {
            resolve: slidesToShowPlugin,
            options: {
              numberOfSlides: 3,
            },
          },
        ]}
        breakpoints={{
          980: {
            plugins: [
              "infinite",
              "arrows",
              {
                resolve: slidesToShowPlugin,
                options: {
                  numberOfSlides: 2,
                },
              },
              {
                resolve: autoplayPlugin,
                options: {
                  interval: 1400,
                },
              },
            ],
          },
          620: {
            plugins: [
              "infinite",
              "arrows",
              {
                resolve: slidesToShowPlugin,
                options: {
                  numberOfSlides: 1,
                },
              },
              {
                resolve: autoplayPlugin,
                options: {
                  interval: 3500,
                },
              },
            ],
          },
        }}
        animationSpeed={1000}
      >
        <div className="box_item_stories">
          <div className="item_stories">
            <div className="sec_author">
              <img
                src="https://cdn-icons-png.flaticon.com/512/607/607548.png"
                alt="Innovación"
              />
              <div className="author_info">
                <p className="fw_700 m-0 p-0">Dr. Alberto Martínez</p>
                <p>Hospital Centro Médico</p>
              </div>
            </div>
            <p className="comment">
              "La logística fue impecable, desde la planeación hasta el cierre.
              El registro digital y producción audiovisual superaron nuestras
              expectativas"
            </p>
            <div className="rating-stars">
              <span className="star active">★</span>
              <span className="star active">★</span>
              <span className="star active">★</span>
              <span className="star active">★</span>
              <span className="star">★</span>
            </div>
          </div>
        </div>
        <div className="box_item_stories">
          <div className="item_stories">
            <div className="sec_author">
              <img
                src="https://cdn-icons-png.flaticon.com/512/607/607548.png"
                alt="Innovación"
              />
              <div className="author_info">
                <p className="fw_700 m-0 p-0">Dra. Verónica Sánchez</p>
                <p>Instituto Psiquiátrico Nacional</p>
              </div>
            </div>
            <p className="comment">
              "Contamos con una plataforma ágil para nuestros asistentes y una
              transmisión en vivo de alta calidad. Fue una experiencia sin
              estrés."
            </p>
            <div className="rating-stars">
              <span className="star active">★</span>
              <span className="star active">★</span>
              <span className="star active">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
            </div>
          </div>
        </div>
        <div className="box_item_stories">
          <div className="item_stories">
            <div className="sec_author">
              <img
                src="https://cdn-icons-png.flaticon.com/512/607/607548.png"
                alt="Innovación"
              />
              <div className="author_info">
                <p className="fw_700 m-0 p-0">Dr. Mauricio González</p>
                <p>Fundación Médica Oncológica</p>
              </div>
            </div>
            <p className="comment">
              "JC Innovation se encargó de todo: escenografía, sonido, personal
              técnico… Todo funcionó perfecto y sin contratiempos."
            </p>
            <div className="rating-stars">
              <span className="star active">★</span>
              <span className="star active">★</span>
              <span className="star active">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
            </div>
          </div>
        </div>
        <div className="box_item_stories">
          <div className="item_stories">
            <div className="sec_author">
              <img
                src="https://cdn-icons-png.flaticon.com/512/607/607548.png"
                alt="Innovación"
              />
              <div className="author_info">
                <p className="fw_700 m-0 p-0">Dra. Elena Villalobos</p>
                <p>Clínica de Reproducción Avanzada</p>
              </div>
            </div>
            <p className="comment">
              "La atención fue personalizada y se adaptaron a nuestras
              necesidades. La experiencia del asistente fue realmente
              excepcional."
            </p>
            <div className="rating-stars">
              <span className="star active">★</span>
              <span className="star active">★</span>
              <span className="star active">★</span>
              <span className="star">★</span>
              <span className="star">★</span>
            </div>
          </div>
        </div>
      </Carousel>
    </div>
  );
};
